import {combineReducers} from "redux";

import {casinoReducer} from "@atg-casino-shared/data-access-root-reducer";
import {modalsReducer as modals} from "@atg-shared/modals-data-access";
import {limitsReducer as limits} from "@atg-responsible-gambling-shared/limits-domain";
import {selfExclusion} from "@atg-responsible-gambling-shared/self-exclusion-domain";
import {activeBreakpoint} from "atg-match-media/domain/matchMediaReducer";

const createRootReducer = () =>
    combineReducers({
        activeBreakpoint,
        accessToken: () => window._frameStore.getState().accessToken,
        auth: () => window._frameStore.getState().auth,
        limits,
        modals,
        realityCheck: () => window._frameStore.getState().realityCheck, // Verify if we could move it to frame
        router: () => window._frameStore.getState().router,
        responsibleGamingHeader: () =>
            window._frameStore.getState().responsibleGamingHeader, // Verify if we could move it to frame
        user: () => window._frameStore.getState().user,
        casino: casinoReducer,
        selfExclusion,
        mainNavbar: () => window._frameStore.getState().mainNavbar,
    });

export default createRootReducer;
